"use client";

import { useEffect, useSyncExternalStore } from "react";
import type { Locale } from "@/i18n/config";

// Dil seçicinin hedef adresini sayfanın kendisinin bildirmesi için (Site Yönetimi sayfalarının İngilizce/Türkçe
// adresleri panelden gelir, yoldan çıkarılamaz). Sayfa <AlternateLinks> çizer; dil seçici useAlternateLinks ile okur.
// Sunucu çiziminde bilinmez (varsayılan: dilin ana sayfası); tarayıcıda sayfa açılınca doğru adrese döner.

type Links = Partial<Record<Locale, string>>;

let current: Links | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

export function useAlternateLinks(): Links | null {
  return useSyncExternalStore(subscribe, () => current, () => null);
}

export function AlternateLinks({ links }: { links: Links }) {
  const key = JSON.stringify(links);
  useEffect(() => {
    current = JSON.parse(key) as Links;
    emit();
    return () => {
      current = null;
      emit();
    };
  }, [key]);
  return null;
}
